import React from 'react';
import { MenuProps, components } from 'react-select';
import { Button } from '@unmind/design-system';
import { useTranslation } from 'react-i18next';
import { FilterOptionType } from 'Book/shared';
import * as S from '../../styles';

type TalkFilterMenuProps = {
  description?: string;
  footnote?: string;
  onDone(): void;
};

export default (
  props: MenuProps<FilterOptionType, true> & TalkFilterMenuProps,
) => {
  const { t } = useTranslation('book', {
    keyPrefix: 'therapyAndCoaching.filters',
  });
  const hasSelectedItems = props.getValue().length > 0;

  return (
    <S.Wrapper>
      <components.Menu {...props}>
        <>
          <S.Description>{props.description}</S.Description>
          {props.children}
          {props.footnote && <S.Footnote>{props.footnote}</S.Footnote>}
          <S.ButtonsContainer>
            <S.ButtonWrapper>
              <Button
                variant="tertiary"
                size="small"
                label={t('ctas.clear')}
                onClick={props.clearValue}
                disabled={!hasSelectedItems}
                tabIndex={-1}
                aria-hidden
              />
            </S.ButtonWrapper>
            <S.ButtonWrapper>
              <Button
                variant="primary"
                size="small"
                label={t('ctas.done')}
                onClick={props.onDone}
                tabIndex={-1}
                aria-hidden
              />
            </S.ButtonWrapper>
          </S.ButtonsContainer>
        </>
      </components.Menu>
    </S.Wrapper>
  );
};
